import { POST_ABOUT_US_START } from '../../types';

export const post_about_us = (payload) => ({
  type: POST_ABOUT_US_START,
  payload,
});